import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const AnalyticsAndInsightsSkeleton = () => {
  return (
    <Box sx={{ p: 3 }}>
      {/* Header Skeleton */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
        <Skeleton variant="circular" width={60} height={60} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" height={28} />
          <Skeleton variant="text" width="70%" height={22} />
        </Box>
      </Box>

      {/* Filter/Search Bar */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="rectangular" width="100%" height={60} sx={{ borderRadius: 2 }} />
      </Box>

      {/* Daily Active Users (Small Cards) */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {[...Array(3)].map((_, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',
              }}
            >
              <Skeleton variant="text" width="40%" height={28} />
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="60%" height={16} />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Two Chart Sections Side by Side */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {[...Array(2)].map((_, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',
              }}
            >
              <Skeleton variant="text" width="50%" height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="80%" height={18} sx={{ mb: 2 }} />
              <Skeleton variant="rectangular" width="100%" height={250} sx={{ borderRadius: 1 }} />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Real-Time Users Chart */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width="30%" height={26} sx={{ mb: 1 }} />
        <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
      </Box>

      {/* Weekly Users */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width="30%" height={26} sx={{ mb: 1 }} />
        <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
      </Box>

      {/* Monthly Users */}
      <Box>
        <Skeleton variant="text" width="30%" height={26} sx={{ mb: 1 }} />
        <Skeleton variant="rectangular" width="100%" height={200} sx={{ borderRadius: 2 }} />
      </Box>
    </Box>
  );
};

export default AnalyticsAndInsightsSkeleton;
